/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getRelationships.defs.js'
export { main as default } from './getRelationships.defs.js'
